var _rect, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconOrangeLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 7.25C12.7835 7.25 10.1666 9.8669 10.1666 13.0833C10.1666 14.0489 10.408 15.0063 10.867 15.8555L15.681 24.562C15.7451 24.6781 15.8672 24.75 16 24.75C16.1328 24.75 16.2549 24.6781 16.319 24.562L21.1348 15.8526C21.5919 15.0063 21.8333 14.0489 21.8333 13.0833C21.8333 9.8669 19.2164 7.25 16 7.25ZM16 16C14.3917 16 13.0833 14.6916 13.0833 13.0833C13.0833 11.4751 14.3917 10.1667 16 10.1667C17.6082 10.1667 18.9166 11.4751 18.9166 13.0833C18.9166 14.6916 17.6082 16 16 16Z",
    fill: "#E1591F"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#E3E3E3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_74"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5,
    height: 17.5,
    fill: "white",
    transform: "translate(7.25 7.25)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrangeLocation);
export default __webpack_public_path__ + "static/media/icon-orange-location.b105716f8c723c31e0072d31b70ff49b.svg";
export { ForwardRef as ReactComponent };